// Which merchant the native shell is currently showing.
//
// A dedicated (single-merchant) build never sets this — its merchant is fixed
// in the generated merchant.json. The flagship build does: the merchant is
// chosen at runtime or arrived at by deep link, and the choice has to survive
// relaunch, so it is persisted. See ADR 0005.
//
// Holds only the domain. Everything else about the merchant — logo, name,
// colors, skin, currency — comes from /public/store/resolve keyed on it, and
// is server state, so it does not belong here.
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { MERCHANT_STORAGE_KEY } from '@core/constants/auth';

export const useMerchantStore = create(
  persist(
    (set) => ({
      /** Full origin, e.g. "https://suryadev.bytize.in". Empty when unset. */
      selectedDomain: '',

      setMerchantDomain: (selectedDomain) => set({ selectedDomain: selectedDomain || '' }),
      clearMerchant: () => set({ selectedDomain: '' }),
    }),
    {
      name: MERCHANT_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
